<template>
  <b-modal
    id="modal-points-redemption"
    body-bg-variant="light"
    :modal-class="[terminal && terminal.scale ? 'popupQuantity' : 'popup-price', 'points-redemption-modal']"
    no-close-on-backdrop
    no-fade
    hide-footer
    @shown="onShown"
  >
    <template
      slot="modal-header"
      slot-scope="{ close }"
    >
      <b-button
        variant="outline-light"
        class="points-redemption-cancel"
        @click="close()"
      >
        {{ $t("quantitypopup.cancel") }}
      </b-button>
      <h5>
        Redeem Points
      </h5>
      <div style="width: 58px;" /> <!-- Spacer to balance header -->
    </template>

    <div class="points-redemption-body">
      <div class="points-redemption-card">
        <span class="points-redemption-amount">{{ pointsStr || '0' }}</span>
        <span class="points-redemption-label">points</span>
        <div class="points-redemption-divider" />
        <span class="points-redemption-value">{{ currency }} {{ (parseFloat(pointsStr || 0) * conversionRate).toFixed(2) }}</span>

        <div class="points-redemption-meta">
          <span class="points-redemption-available">
            <strong>{{ customerPoints - parseFloat(pointsStr || 0) }}</strong> available
          </span>
          <button
            type="button"
            class="points-redemption-max"
            @click="setMaxPoints"
          >
            Use max &middot; {{ maxRedeemablePoints }}
          </button>
        </div>
      </div>
    </div>

    <NumKeyboard
      :enable-dot="false"
      :enable-minus="false"
      @onTypeNum="typeNum"
      @save="passSave"
    />
  </b-modal>
</template>

<script>
import NumKeyboard from "@/components/keyboards/NumKeyboard";
import { mapGetters } from "vuex";

export default {
  name: "ModalPointsRedemption",
  components: {
    NumKeyboard
  },
  props: {
    customerPoints: {
      type: Number,
      default: 0
    },
    maxRedeemablePoints: {
      type: Number,
      default: 0
    },
    conversionRate: {
      type: Number,
      default: 0.01
    },
    initialPoints: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      pointsStr: "",
      changed: false
    };
  },
  computed: {
    ...mapGetters({
      currency: "config/currency",
      terminal: "config/terminal",
    }),
  },
  methods: {
    onShown() {
      // If we have initial points (editing existing redemption), show them
      if (this.initialPoints > 0) {
        this.pointsStr = this.initialPoints.toString();
        this.changed = false;
      } else {
        this.pointsStr = "";
        this.changed = false;
      }
    },
    setMaxPoints() {
      this.pointsStr = this.maxRedeemablePoints.toString();
      this.changed = true;
    },
    typeNum(num) {
      const qtyLengthLimit = 12;

      if (num === "C") {
        this.pointsStr = "";
      } else if (num === ".") {
        // Points usually integers, ignore dot
        return;
      } else if (num === "-") {
        // Negative points not allowed
        return;
      } else if ((this.pointsStr + 1).length >= qtyLengthLimit) {
        return;
      } else {
        if (this.changed) {
          this.pointsStr += num.toString();
        } else {
          this.pointsStr = num.toString();
        }
        this.changed = true;
      }

      // Auto-cap at maxRedeemablePoints
      const currentVal = parseInt(this.pointsStr || 0);
      if (currentVal > this.maxRedeemablePoints) {
        this.pointsStr = this.maxRedeemablePoints.toString();
      }
    },
    passSave() {
      if (this.pointsStr === "") {
        this.pointsStr = "0";
      }

      const points = parseInt(this.pointsStr);

      if (!isNaN(points) && points > 0) {
        this.$emit("save", points);
      } else {
        // If 0 or invalid, maybe remove the item? For now just emit 0
        this.$emit("save", 0);
      }
    }
  }
};
</script>

<style scoped>
.points-redemption-cancel {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  color: #2196F3 !important;
  font-weight: 500;
}

.points-redemption-body {
  padding: 20px 20px 4px;
}

.points-redemption-card {
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 16px;
  padding: 22px 16px 18px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.points-redemption-amount {
  font-size: 40px;
  line-height: 1.1;
  font-weight: 700;
  color: #111827;
}

.points-redemption-label {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #9CA3AF;
  margin-top: 2px;
}

.points-redemption-divider {
  width: 32px;
  height: 1px;
  background: #E5E7EB;
  margin: 14px 0 12px;
}

.points-redemption-value {
  font-size: 16px;
  font-weight: 500;
  color: #4B5563;
}

.points-redemption-meta {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #E5E7EB;
}

.points-redemption-available {
  font-size: 14px;
  color: #6B7280;
}

.points-redemption-available strong {
  color: #111827;
  font-weight: 600;
}

.points-redemption-max {
  border: none;
  background: #DBEAFE;
  color: #2563EB;
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  padding: 14px 22px;
  border-radius: 24px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.points-redemption-max:hover {
  background: #BFDBFE;
}

.points-redemption-max:active {
  transform: scale(0.97);
}
</style>

<style>
.points-redemption-modal .modal-content {
  border-radius: 16px;
  overflow: hidden;
}
</style>
